import { buildPyClass, chainOrSuspend, pyNone } from "@Sk";
import PyDefUtils from "PyDefUtils";
import { BASE_MODULES } from "@designer/python-environment";
import { AnvilHookSpec, Component, ComponentConstructor, DropZone } from "@runtime/components/Component";

const { LinearPanel } = BASE_MODULES["anvil"];

const mkDesignerHookSpec = (oldHookSpec: AnvilHookSpec): Partial<AnvilHookSpec> => {
    return {
        enableDropMode(dragging) {
            this.anvil$hooks.disableDropMode!();
            const dropZoneElements = this._anvil.dropZoneElements;
            const genDropZone = (idx: number) => {
                const element = document.createElement("li");
                dropZoneElements.push(element);
                return {
                    element,
                    dropInfo: {
                        minChildIdx: idx,
                        maxChildIdx: idx,
                    },
                };
            };

            const dzs: DropZone[] = [];
            const containerElements = [...this._anvil.elements.lpul.children];
            for (let i = 0; i < containerElements.length; i++) {
                const dz = genDropZone(i);
                containerElements[i].insertAdjacentElement("beforebegin", dz.element);
                dzs.push(dz);
            }
            const endDz = genDropZone(containerElements.length);
            this._anvil.elements.lpul.insertAdjacentElement("beforeend", endDz.element);
            dzs.push(endDz);

            return dzs;
        },

        disableDropMode() {
            const dropZoneElements = this._anvil.dropZoneElements;
            for (const elt of dropZoneElements) {
                elt.remove();
            }
            this._anvil.dropZoneElements = [];
        },
    };
};

export const DesignLinearPanelV3 = buildPyClass(
    BASE_MODULES["anvil"],
    ($gbl, $loc) => {
        $loc["__init__"] = PyDefUtils.funcFastCall(([self]: [Component], kws) =>
            chainOrSuspend(LinearPanel.prototype.tp$init.call(self, [], kws), () => {
                self._anvil.dropZoneElements = [] as HTMLElement[];
                return pyNone;
            })
        );
        const oldHookSpec = LinearPanel.prototype.anvil$hookSpec;
        $loc.anvil$hookSpec = Object.assign(Object.create(oldHookSpec), mkDesignerHookSpec(oldHookSpec));
    },
    "DesignLinearPanelV3",
    [LinearPanel]
) as ComponentConstructor;
